module.exports = __webpack_public_path__ + "img/weddingbands@2x.fe5dc6e.png";